import { ChangeDetectionStrategy, Component, NgZone, OnInit, inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { KeycloakService } from "src/app/services/keycloak.service";
import { DisplayMode, getIsDisplayMode } from "src/app/utils/router.utils";
import { AsyncPipe } from "@angular/common";
import { CheckboxModule } from "@storeblocks/checkbox-ng";
import { ListAdvisorAccessesComponent } from "src/app/components/list-advisor-accesses/list-advisor-accesses.component";
import { MenuFooterService } from "src/app/services/menu-footer.service";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, CheckboxModule, ListAdvisorAccessesComponent],
})
export class MenuComponent implements OnInit {
  private readonly keycloakService = inject(KeycloakService);
  private readonly ngZone = inject(NgZone);
  private readonly menuFooterService = inject(MenuFooterService);

  public readonly isAdvisorContext$ = this.keycloakService.isAdvisorContext$;
  public readonly advisorIncognitoMode$ = this.keycloakService.getAdvisorIncognitoMode();

  public ngOnInit(): void {
    this.ngZone.runOutsideAngular(async () => {
      const isAuthenticated = this.keycloakService.authenticated();
      const isDisplayModeApp = getIsDisplayMode(DisplayMode.App);
      const isAdvisorContext = await firstValueFrom(this.keycloakService.isAdvisorContext$);

      if (isAuthenticated && !isDisplayModeApp && !isAdvisorContext) {
        await this.menuFooterService.startHeaderFooter();
      }
    });
  }

  public toggleIncognitoMode(event: any): void {
    this.keycloakService.setAdvisorIncognitoMode(event.target.checked);
  }
}
